export default {
    pointerEvents: 'none',
};
